import {List, Picker} from "antd-mobile";
import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";

// wrapped List.Item so we can transform the value passed as 'extra' prop
const PickerItem = ({extra, children, extraFn = e => e, undefinedExtra='', ...props}) => {
    return (
        <List.Item
            extra={extraFn(extra)||undefinedExtra}
            {...props}
        >{children}</List.Item>
    )
};
export const SinglePicker = ({valueDisplay, undefinedDisplay = 'select...', label, onChange, value, ...props}) => {

    const [localValue, setLocalValue] = useState([value]);

    // translate the single value to the array Picker expects
    useEffect(() => {
        setLocalValue(lastValue => lastValue[0] === value ? lastValue : [value]);
    }, [value]);

    return (
        <Picker
            cols={1}
            okText={'Done'}
            dismissText={'Cancel'}
            className={'mm-form'}  // not in form hierarchy
            extra={value || undefinedDisplay} // intial only
            onChange={v => {
                if (v[0]!==value) {  // fires when no change...
                    onChange(v[0]);  // and back again
                }
            }}
            value={localValue}
            {...props}
        >
            <PickerItem
                arrow="horizontal"
                extraFn={valueDisplay}
                undefinedExtra={undefinedDisplay}
            >{label}
            </PickerItem>
        </Picker>
    );
};
SinglePicker.propTypes = {
    data: PropTypes.array.isRequired,
    label: PropTypes.any,
    valueDisplay: PropTypes.func
};